import React, { useState } from 'react';
import { client } from '@/utils/netlify';
import { getCookie } from 'cookies-next';
import { checkUserLogin, createUserLogin, customerLoginData, handleSignOut } from '@/helpers/userHelpers';
import { loggedInUser } from '@/redux/actions/loggedInUser';
import { useDispatch } from 'react-redux';
import { setCustomer } from '@/components/common/Nosto';
import { errorMessages } from "@/utils/constants";
import { checkIfEmail } from '@/helpers/generalHelper';
import EditPassword from './EditPassword';
import EditName from './EditName';
import { reportError } from '@/helpers/errorHelper';
import InputField from "@/components/common/CommonInputComponent";


const EditDetails = (props) => {
  const { userDetails, editPageState, styles } = props;

  const [email, setEmail] = useState(userDetails.email);
  let updatedSuccess = errorMessages.authentication.updatedSuccess;
  const [emailErrorMessage, setEmailErrorMessage] = useState(false);

  const [disable, setDisable] = useState(false);
  const [successMsg, setSuccessMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [firstNameChanged, setFirstNameChanged] = useState(false);
  const [lastNameChanged, setLastNameChanged] = useState(false);
  const dispatch = useDispatch();

  function handleEmailFormat(email) {
    if (email) {
      var validateEmail = checkIfEmail(email);
      if (!validateEmail) {
        setEmailErrorMessage(errorMessages.authentication.invalidEmail);
        return false
      } else {
        setEmailErrorMessage(null);
        return true
      }
    }
    else {
      setEmailErrorMessage(errorMessages.authentication.invalidEmail);
      return false
    }
  }



  const submitFormEdit = async (obj) => {
    let data;
    /* check edit type */
    if (editPageState === 'name') {
      data = { firstName: obj.firstName, lastName: obj.lastName };
    }
    else if (editPageState === 'email') {
      data = { email };
    }
    else if (editPageState === 'password') {
      data = { password: obj.password };
    }
    /* Get user token from cookie */
    let cookie_data = JSON.parse(getCookie("userdataToken"));
    if (!cookie_data) {
      /* In case cookie is not available */
      alert("Please reload the browser");
      return;
    }
    let token = cookie_data.accessToken;
    let request = { data: data, type: editPageState, token: token };
    setLoading(true);
    try {
      /* Send data to Shopify */
      let res = await client("customer-edits", request);

      if (editPageState === 'password') {
        /* Sign in require in case of password update */
        if (res && res.customerUpdate && res.customerUpdate.customerAccessToken && res.customerUpdate.customerAccessToken.accessToken) {
          const userData = await customerLoginData({
            token:
              res.customerUpdate.customerAccessToken.accessToken
          });
          setCustomer(userData);
          await createUserLogin(
            res.customerUpdate,
            userData,
            res.customerUpdate.customerAccessToken.expiresAt
          );
          setSuccessMessage(updatedSuccess);
        }
        setLoading(false);
        return;
      }

      /* Show success message */
      if (editPageState === 'name') {
        if (!res?.customerUpdate?.customerUserErrors[0]?.message) {
          if (res.customerUpdate.customer.firstName !== userDetails.firstName) {
            setFirstNameChanged(true);
          }
          else {
            setFirstNameChanged(false);
          }
          if (res.customerUpdate.customer.lastName !== userDetails.lastName) {
            setLastNameChanged(true);
          }
          else {
            setLastNameChanged(false);
          }
          setSuccessMessage(updatedSuccess)
        }
      }
      // Email exists error
      if (editPageState === 'email') {
        if (res?.customerUpdate?.customerUserErrors[0]?.message) {
          setEmailErrorMessage(errorMessages.authentication.emailInUseError);
        }
        else if (res.customerUpdate.customer.email) {
          setSuccessMessage(updatedSuccess)
        }
      }
      setLoading(false);
      /* Refresh side cart information */
      let user_data = await checkUserLogin(token);
      if (user_data && user_data.userLoggedIn) {
        dispatch(loggedInUser(user_data));
      }
    }
    catch (error) {
      reportError("Error in edit account details")
      reportError(error)
    }
  }

  const handleEmailSubmit = () => {
    if (email && handleEmailFormat(email)) {
      submitFormEdit();
    }
  }

  /* Page render */
  if (editPageState === 'email') {
    return (
      <div className={`${styles.account_card} edit_details wrapper`}>
        <div className="item-wrapper mb-30">
        <InputField
            type="email"
            id="email"
            name="email"
            label="Email address*"
            placeholder=" "
            autoComplete="email"
            ariaLabel="your-email"
            className="normal-md small-xs normal-sm"
            errorMessage={emailErrorMessage}
            onChange={e => {
              setEmail(e.currentTarget.value);
              setSuccessMessage("");
            }}
            onBlur={e => {
              handleEmailFormat(e.target.value);
            }}
            isEmail={true}
            isEditTab={true}
            successMsg={successMsg}
            updatedSuccess={updatedSuccess}
            value={email}
          />
        </div>

        <button className={`btn-primary w-full ${disable ? "disabled" : ""} btn_loading ${loading ? "loading" : ""}`} onClick={handleEmailSubmit}><span>Save</span></button>
      </div>
    )
  }
  else if (editPageState === 'password') {
    return (
      <EditPassword successMsg={successMsg} setSuccessMessage={setSuccessMessage}
        editPageState={editPageState} loading={loading} submitFormEdit={submitFormEdit} styles={styles} />
    )
  }

  return (
    <EditName setSuccessMessage={setSuccessMessage}
      userDetails={userDetails} loading={loading}
      submitFormEdit={submitFormEdit}
      styles={styles}
      successMsg={successMsg}
      firstNameChanged={firstNameChanged}
      lastNameChanged={lastNameChanged}
      updatedSuccess={updatedSuccess}
    />
  )
}
export default EditDetails
